(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2391],{

/***/ 58966:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrenamientos/official-agile-coach-certification-training",
      function () {
        return __webpack_require__(58394);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ TrainingMarketingPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/domain/Training/MarketingPageWrapper.js
var MarketingPageWrapper = __webpack_require__(94664);
// EXTERNAL MODULE: ./src/domain/Training/MarketingHero.js + 1 modules
var MarketingHero = __webpack_require__(90493);
// EXTERNAL MODULE: ./src/domain/Training/MarketingHighlightCopy.js
var MarketingHighlightCopy = __webpack_require__(18141);
// EXTERNAL MODULE: ./src/domain/Training/MarketingContent.js
var MarketingContent = __webpack_require__(13789);
// EXTERNAL MODULE: ./src/domain/Training/MarketingTrainers.js
var MarketingTrainers = __webpack_require__(55344);
// EXTERNAL MODULE: ./src/domain/Training/MarketingFeatures.js
var MarketingFeatures = __webpack_require__(91873);
// EXTERNAL MODULE: ./src/components/Check/index.js + 1 modules
var Check = __webpack_require__(29468);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/domain/Training/MarketingSection.js
var MarketingSection = __webpack_require__(71105);
;// CONCATENATED MODULE: ./src/domain/Training/MarketingProgram.js




function MarketingProgram(param) {
    var program = param.program;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingSection/* default */.Z, {
        className: "bg-white",
        sectionTitle: "Son 6 cursos de 2 semanas cada uno, valorados individualmente en USD 350",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            maxWidth: "max-w-screen-lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-y-16",
                children: program.map(function(param, index) {
                    var subject = param.subject, content = param.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex relative lg:col-span-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute z-0 top-0 left-0 text-6xl font-extrabold text-gray-500 pointer-events-none leading-none opacity-10 -mt-4 -ml-6",
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative w-full z-10 space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-xl font-medium",
                                        children: subject
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "list-none space-y-2",
                                        children: content.map(function(param, subjectIndex) {
                                            var title = param.title;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-start space-x-3 text-gray-500 hover:text-gray-700 cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-px pt-px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                            className: "text-green-400"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-1",
                                                        children: title
                                                    })
                                                ]
                                            }, "program-".concat(index, "-subject-").concat(subjectIndex));
                                        })
                                    })
                                ]
                            })
                        ]
                    }, "program-".concat(index));
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
;// CONCATENATED MODULE: ./src/domain/Training/MarketingPricing.js




function MarketingPricingPublicPrice(param) {
    var publicPrice = param.publicPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center pb-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-medium",
                children: "Total de programas"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block flex-1 mx-4 border-t-2 border-dashed border-gray-200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-through text-red-300 font-medium",
                children: "$".concat(publicPrice)
            })
        ]
    });
}
function MarketingPricingPromotionalDiscount(param) {
    var promotionalDiscount = param.promotionalDiscount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center pb-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-medium",
                children: "Descuento promocional"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block flex-1 mx-4 border-t-2 border-dashed border-gray-200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-red-300 font-medium",
                children: "-$".concat(promotionalDiscount)
            })
        ]
    });
}
function MarketingPricingEarlyBirdDiscount(param) {
    var priceEarlyBirdDiscount = param.priceEarlyBirdDiscount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "items-center hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-medium",
                children: "Descuento Early Bird"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block flex-1 mx-4 border-t border-dashed border-gray-300"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-red-300 font-medium",
                children: "-$".concat(priceEarlyBirdDiscount)
            })
        ]
    });
}
function MarketingPricingByProgram(param) {
    var priceByProgram = param.priceByProgram, publicPrice = param.publicPrice, promotionalDiscount = param.promotionalDiscount, priceEarlyBirdDiscount = param.priceEarlyBirdDiscount;
    var hasPublicPrice = publicPrice !== null;
    var hasPromotionalDiscount = promotionalDiscount !== null;
    var hasPriceEarlyBirdDiscount = priceEarlyBirdDiscount !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white shadow rounded-xl mt-16 mx-auto md:max-w-xs lg:mx-0 lg:max-w-full lg:rounded-r-none lg:min-w-0 lg:w-2/5 lg:mt-0 overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-8 py-6 bg-gray-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-gray-700 text-lg sm:text-xl text-center font-bold my-0",
                    children: "Programas"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-10 px-10 space-y-6 divide-y divide-gray-200",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "text-gray-400 text-sm",
                        children: priceByProgram.map(function(param, index) {
                            var subject = param.subject, referencialPrice = param.referencialPrice;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-medium",
                                        children: subject
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block flex-1 mx-4 border-t-2 border-dashed border-gray-200"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "line-through font-medium text-gray-300",
                                        children: "$".concat(referencialPrice)
                                    })
                                ]
                            }, "pricing-program-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pt-6 text-sm",
                        children: [
                            hasPublicPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPricingPublicPrice, {
                                publicPrice: publicPrice
                            }),
                            hasPromotionalDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPricingPromotionalDiscount, {
                                promotionalDiscount: promotionalDiscount
                            }),
                            hasPriceEarlyBirdDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPricingEarlyBirdDiscount, {
                                priceEarlyBirdDiscount: priceEarlyBirdDiscount
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-10 px-10 md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    className: "w-full text-center text-lg sm:text-xl inline-block rounded-full focus:outline-none bg-green-500 shadow hover:bg-green-600 focus:bg-green-700 text-white font-semibold px-6 py-2 sm:py-3",
                    href: "/clases",
                    children: "Inscr\xedbete hoy mismo"
                })
            })
        ]
    });
}
function MarketingPricingTableContent(param) {
    var pricingTableContent = param.pricingTableContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "px-10 space-y-2",
        children: pricingTableContent.map(function(param, index) {
            var text = param.text;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "flex items-start space-x-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-green-400 mt-px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-normal text-gray-600",
                        children: text
                    })
                ]
            }, "pricing-table-content-".concat(index));
        })
    });
}
function MarketingPricing(param) {
    var price = param.price, pricingTableContent = param.pricingTableContent, priceWithDiscount = param.priceWithDiscount, promotionalDiscount = param.promotionalDiscount, publicPrice = param.publicPrice, priceByProgram = param.priceByProgram;
    var hasPricingTableContent = pricingTableContent !== null;
    var hasPricingByProgram = priceByProgram !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingSection/* default */.Z, {
        className: "bg-gray-900 text-white",
        sectionTitle: "Obt\xe9n tu cupo hoy mismo accediento a los precios de oferta",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "block lg:flex lg:items-center lg:justify-center lg:flex-row-reverse text-gray-900",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto w-full md:max-w-lg lg:mx-0 lg:min-w-0 lg:w-3/5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white shadow-xl rounded-lg lg:rounded-xl w-full relative overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-8 py-6 bg-gray-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    className: "text-gray-900 text-lg sm:text-xl text-center my-0 space-x-2 flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-bold",
                                            children: "Precio referencial desde"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-gray-400 text-lg",
                                            children: "*"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-10 lg:py-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-center py-6 lg:py-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "hidden -ml-8 text-right text-2xl leading-8 font-semibold text-gray-400 tracking-wide line-through sm:text-3xl sm:leading-9",
                                            children: [
                                                "$",
                                                price
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "inline-flex items-center font-display text-5xl md:text-6xl font-bold text-black mr-3 sm:mr-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-2xl md:text-3xl",
                                                    children: "$"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: price
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "inline-flex items-center font-display text-xl md:text-2xl font-medium text-gray-400 mr-3 sm:mr-4",
                                            children: "USD"
                                        })
                                    ]
                                })
                            }),
                            hasPricingTableContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPricingTableContent, {
                                pricingTableContent: pricingTableContent
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center mt-12 px-10 py-6 space-y-4 bg-gray-100 rounded-b-lg lg:rounded-b-xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    className: "w-full text-lg sm:text-xl inline-block rounded-full focus:outline-none bg-red-500 shadow hover:bg-red-600 focus:bg-red-700 text-white font-semibold px-6 py-2 sm:py-3",
                                    href: "/clases",
                                    children: "Obt\xe9n esta promoci\xf3n hoy mismo"
                                })
                            })
                        ]
                    })
                }),
                hasPricingByProgram && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPricingByProgram, {
                    publicPrice: publicPrice,
                    priceByProgram: priceByProgram,
                    promotionalDiscount: promotionalDiscount
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/domain/Training/MarketingTestimonials.js
var MarketingTestimonials = __webpack_require__(28570);
// EXTERNAL MODULE: ./src/domain/Training/MarketingFAQs.js
var MarketingFAQs = __webpack_require__(18346);
// EXTERNAL MODULE: ./src/domain/Training/MarketingContact.js
var MarketingContact = __webpack_require__(30398);
;// CONCATENATED MODULE: ./src/pages/entrenamientos/official-agile-coach-certification-training.js













var __N_SSG = true;
function TrainingMarketingPage(param) {
    var training = param.training;
    var hasContent = training.content !== null;
    var hasTrainers = training.details.trainers !== null;
    var hasWhatIsLearned = training.details.whatIsLearned !== null;
    var hasProgramSubjects = training.details.programSubjects !== null;
    var hasTestimonials = training.details.testimonials !== null;
    var hasPricingTable = training.details_agile_coach !== null;
    var hasFAQs = training.details.faqs !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MarketingPageWrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingHero/* default */.Z, (0,_object_spread/* default */.Z)({
                heroCopy: "Official Agile Coach",
                heroLead: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "leading-relaxed",
                    children: [
                        "El programa de entrenamiento\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "m\xe1s completo para hispanohablantes"
                        }),
                        "\xa0donde adquieres y desarrollas las competencias necesarias para ejercer como un\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "text-gray-900",
                            children: "Agile Coach"
                        }),
                        "."
                    ]
                }),
                heroImage: "w_710,h_910/v1610683730/personas/official-agile-coach-certification_ng96yw.png",
                heroImageAlt: "Official Agile Coach Training",
                heroCTANormalClasses: "bg-red-600",
                heroCTAHoverClasses: "hover:bg-red-700",
                heroCTAFocusClasses: "focus:bg-red-700 focus:ring-red-600 focus:ring-opacity-20",
                heroHighlighColor: "text-red-600",
                heroBackgroundFrom: "from-red-100",
                heroBackgroundTo: "to-white",
                stripesBackgroundFrom: "from-red-500",
                stripesBackgroundTo: "to-transparent",
                stripesBackgroundDarkerFrom: "from-red-700",
                stripesBackgroundDarkerTo: "to-transparent"
            }, training.details)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingHighlightCopy/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "leading-relaxed",
                    children: [
                        "El programa\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "font-semibold text-white",
                            children: "Official Agile Coach"
                        }),
                        "\xa0es el \xfanico que te capacita para convertirte en un\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "font-semibold text-white",
                            children: "Experto Agile"
                        }),
                        "\xa0con liderazgo y conocimiento para ejecutar los procesos\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "font-semibold text-white",
                            children: "Lean-Agile"
                        }),
                        "\xa0en cualquier organizaci\xf3n."
                    ]
                })
            }),
            hasContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingContent/* default */.Z, {
                content: training.content
            }),
            hasTrainers && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingTrainers/* default */.Z, {
                trainers: training.details.trainers
            }),
            hasWhatIsLearned && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingFeatures/* default */.Z, {
                features: training.details.whatIsLearned
            }),
            hasProgramSubjects && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingProgram, {
                program: training.details.programSubjects
            }),
            hasPricingTable && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPricing, (0,_object_spread/* default */.Z)({}, training.details, training.details_agile_coach)),
            hasTestimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingTestimonials/* default */.Z, {
                testimonials: training.details.testimonials
            }),
            hasFAQs && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingFAQs/* default */.Z, {
                faqs: training.details.faqs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingContact/* default */.Z, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,3022,9774,2888,179], function() { return __webpack_exec__(58966); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);